import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function WelcomePage() {
  const navigate = useNavigate();
  const [isOver18, setIsOver18] = React.useState(true);

  const handleYes = () => {
    localStorage.setItem('isOver18', 'true'); // Save confirmation in localStorage
    navigate('/'); // Redirect to the home page
  };

  const handleNo = () => {
    setIsOver18(false);
  };

  return (
    <div className='h-screen flex flex-col items-center justify-center bg-gradient-to-b from-[#242423] to-[#000000] text-white px-4'>
      {/* Welcome Header */}
      <div className='mb-12 md:mb-6'>
        <img
          src='/images/pivara_logo.png'
          alt='Company Logo'
          className='h-64'
        />
      </div>
      <h1 className='text-4xl font-bold mb-8 slavic-font'>ПОМАЖЕ БОГ</h1>

      {/* Age Verification Prompt */}
      <p className='text-lg md:text-xl mb-6 slavic-font'>
        Да ли сте старији од 18 година?
      </p>

      <div className='flex space-x-4'>
        <button
          onClick={handleYes}
          className='bg-gradient-to-r from-yellow-400 to-yellow-800 text-white font-bold py-4 px-12 rounded-lg hover:border-2 border-yellow-500'
        >
          ДА
        </button>
        <button
          onClick={handleNo}
          className='hover:border-2 border-yellow-500 bg-neutral-800 text-white font-bold py-4 px-12 rounded-lg'
        >
          НЕ
        </button>
      </div>
      {!isOver18 && (
        <p className='text-red-500 text-base md:text-base mb-6 slavic-font text-center pt-5'>
          Морате бити старији од 18 година да би приступили овој страници.
        </p>
      )}
    </div>
  );
}
